/* wsapi3-customer-area-page v1.0 */
/* Deploy Version 2026-10-14 10:42:32 */
/* Deploy Version 2026-09-24 19:11:10 */
/* Deploy Version 2026-07-27 16:11:02 */
(function () {
    'use strict';

    /* ═══════════════════════════════════════════════════════
       GUARD VISUAL — oculta a página até confirmar sessão
    ═══════════════════════════════════════════════════════ */
    var _authOverlay = (function () {
        var blockEl = document.querySelector('.cli-block-page');
        if (blockEl) blockEl.style.display = 'none';

        // Overlay de carregamento padrão do site (mesmo spinner/blur usado em
        // produto, checkout, carrinho etc. — ver wsMain.tools.showLoading()
        // em wsapi3-main.js/.css). Antes essa página tinha um spinner próprio
        // (36px, cinza escuro), com tamanho/cor diferente do resto da loja.
        wsMain.tools.showLoading();

        return {
            remove: function () {
                if (blockEl) blockEl.style.display = '';
                wsMain.tools.hideLoading();
            }
        };
    })();

    // Estados "Carregando..." internos (pedidos, favoritos, cashback, detalhe
    // do pedido) ganham o mesmo spinner do resto da loja — texto puro sozinho
    // passava despercebido. Mantém o texto original de cada um, só acrescenta
    // o spinner na frente (ver .section-state--loading no CSS).
    document.querySelectorAll('.section-state[id$="-loading"]').forEach(function (loadingEl) {
        loadingEl.classList.add('section-state--loading');
        loadingEl.innerHTML = wsMain.tools.inlineSpinnerHtml() + '<span>' + loadingEl.textContent + '</span>';
    });

    /* ═══════════════════════════════════════════════════════
       ESTADO GLOBAL
    ═══════════════════════════════════════════════════════ */
    var _session = null;          // dados do usuário logado
    var _orders = {
        records: [],
        page: 1,
        total: 0,
        loading: false,
        loaded: false
    };
    var _addresses = [];          // endereços carregados do servidor
    var _selectedAddrIdx = -1;    // índice do endereço em edição (-1 = novo)
    var _lastSearchedCep = '';    // evita repetir a mesma busca de CEP (input + enter/blur)
    var _personalLoaded = false;  // evita re-carregamento desnecessário
    var _personalPromise = null;  // personal-info/view em andamento (init + seção não duplicam a chamada)
    var _isAffiliate = false;     // record.affiliate do personal-info/view — libera o menu "Afiliado"
    var _affOrders = { page: 1, total: 0, shown: 0, loading: false };
    var _pwdNewPassword = '';     // senha nova aguardando confirmação de código
    var _pwdResetToken = '';      // reset_token retornado pelo forgotPasswordVerify

    /* ═══════════════════════════════════════════════════════
       HELPERS
    ═══════════════════════════════════════════════════════ */
    function el(id) { return document.getElementById(id); }

    // Ícone de olho (mostrar/ocultar) nos campos de senha — mesmo par de ícones
    // usado em wsapi3-identify-flow.js (login/checkout).
    var EYE_ICON = '<svg viewBox="0 0 24 24" fill="none"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.6"/></svg>';
    var EYE_OFF_ICON = '<svg viewBox="0 0 24 24" fill="none"><path d="M3 3l18 18M10.6 10.6a3 3 0 0 0 4.24 4.24M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 7 11 7a13.2 13.2 0 0 1-3.15 3.9M6.1 6.1A13.29 13.29 0 0 0 1 11s4 7 11 7a10.9 10.9 0 0 0 5.1-1.24" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    document.querySelectorAll('.field-password-wrap [data-field-password-toggle]').forEach(function (btn) {
        var input = btn.previousElementSibling;
        if (!input) return;
        btn.innerHTML = EYE_ICON;
        btn.addEventListener('click', function () {
            var show = input.type === 'password';
            input.type = show ? 'text' : 'password';
            btn.innerHTML = show ? EYE_OFF_ICON : EYE_ICON;
            btn.setAttribute('aria-label', show ? 'Ocultar senha' : 'Mostrar senha');
        });
    });

    function setMsg(id, text, type) {
        var div = el(id);
        if (!div) return;
        div.textContent = text || '';
        div.className = 'field-msg' + (type ? ' field-msg--' + type : '');
    }

    function clearMsg(id) { setMsg(id, '', ''); }

    function setLoading(btnId, loading, label) {
        var btn = el(btnId);
        if (!btn) return;
        btn.disabled = loading;
        if (loading) {
            btn.dataset._origText = btn.dataset._origText || btn.firstChild.textContent.trim();
            btn.firstChild.textContent = 'Aguarde... ';
        } else {
            if (btn.dataset._origText) btn.firstChild.textContent = btn.dataset._origText + ' ';
        }
    }

    function fmtPrice(val) {
        return 'R$ ' + Number(val || 0).toFixed(2).replace('.', ',');
    }

    // payment_info.instructions_1/2 (depósito/entrega) podem vir com \n cru — HTML
    // colapsaria a quebra de linha; <br> já existente na string passa direto.
    function nl2br(str) {
        return (str || '').replace(/\n/g, '<br>');
    }

    // Mesma chave de ofuscação usada em wsapi3-checkout-cart.js (createSharePopup) e
    // wsapi3-cart-drawer-rules.js (_buildShareLink) pro link "?share_cart=" — precisa
    // ser idêntica pra bater com o que /carrinho espera ao decodificar o token.
    var CART_SHARE_OBF_KEY = 'kwkbhbvdsojiqwdojr3279tu3qpjawjnvsdjndwopjqwdoh2h9109ejnefj';

    function buildCartShareLink(token) {
        if (!token) return null;
        var shareParam = CART_SHARE_OBF_KEY + token + CART_SHARE_OBF_KEY;
        return window.location.protocol + '//' + window.location.host + '/carrinho?share_cart=' + shareParam;
    }

    function fmtDate(str) {
        if (!str) return '';
        var d = str.substring(0, 10).split('-');
        if (d.length < 3) return str;
        return d[2] + '/' + d[1] + '/' + d[0];
    }

    function fmtDateTime(str) {
        if (!str) return '';
        var parts = str.split(' ');
        var date = fmtDate(parts[0]);
        var time = parts[1] ? parts[1].substring(0, 5) : '';
        return time ? date + ' às ' + time : date;
    }

    function fmtDateToInput(str) {
        // API: yyyy-MM-dd → input: dd/MM/yyyy
        if (!str) return '';
        var d = str.substring(0, 10).split('-');
        if (d.length < 3) return str;
        return d[2] + '/' + d[1] + '/' + d[0];
    }

    function parseDateInput(val) {
        // dd/MM/yyyy → yyyy-MM-dd
        if (!val) return '';
        var parts = val.split('/');
        if (parts.length === 3) return parts[2] + '-' + parts[1] + '-' + parts[0];
        return val;
    }

    function escHtml(str) {
        return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    function onlyDigits(str) {
        return (str || '').replace(/\D/g, '');
    }

    function formatCep(str) {
        var digits = onlyDigits(str).substring(0, 8);
        return digits.length > 5 ? digits.substring(0, 5) + '-' + digits.substring(5) : digits;
    }

    /* ═══════════════════════════════════════════════════════
       SESSÃO / GUARD
    ═══════════════════════════════════════════════════════ */
    async function initSession() {
        try {
            var data = await ApiWS.Calls.session();
            if (!data || !data.ok || !data.user) {
                window.location.href = '/login';
                return;
            }
            _session = data.user;
            _authOverlay.remove();
            initCashbackVisibility();
            // O menu "Afiliado" depende de record.affiliate do personal-info/view,
            // então a chamada sai já no init (as seções Meus dados/Endereços
            // reaproveitam o resultado, sem buscar de novo).
            loadPersonalData();
            navigateFromHash();
        } catch (e) {
            window.location.href = '/login';
        }
    }

    function navigateFromHash() {
        var hash = window.location.hash.replace('#', '').trim();
        var sectionKey = HASH_SECTION_MAP[hash] || 'pedidos';
        // #afiliado direto na URL: só abre depois de confirmar que o cliente é
        // afiliado; quem não é cai em Meus pedidos.
        if (sectionKey === 'afiliado') {
            loadPersonalData().then(function () {
                activateSection(_isAffiliate ? 'afiliado' : 'pedidos');
            });
            return;
        }
        activateSection(sectionKey);
    }

    /* ═══════════════════════════════════════════════════════
       NAVEGAÇÃO
    ═══════════════════════════════════════════════════════ */
    // hash → sectionKey
    var HASH_SECTION_MAP = {
        'meus-pedidos':  'pedidos',
        'meus-dados':    'dados-pessoais',
        'enderecos':     'endereco',
        'favoritos':     'favoritos',
        'cashback':      'cashback',
        'afiliado':      'afiliado',
        'alterar-email': 'alterar-email',
        'alterar-senha': 'alterar-senha'
    };

    function sectionToHash(sectionKey) {
        if (sectionKey === 'pedidos') return 'meus-pedidos';
        if (sectionKey === 'dados-pessoais') return 'meus-dados';
        if (sectionKey === 'endereco') return 'enderecos';
        return sectionKey; // favoritos, cashback, afiliado, alterar-email, alterar-senha
    }

    function pushHash(hash) {
        if (!history.replaceState) return;
        var base = window.location.pathname + window.location.search;
        history.replaceState(null, '', hash ? base + '#' + hash : base);
    }

    var mobileNavTrigger = el('js-mobile-nav-trigger');
    var mobileNavTriggerLabel = el('js-mobile-nav-trigger-label');
    var sidebarEl = el('js-sidebar');

    function closeMobileNav() {
        if (sidebarEl) sidebarEl.classList.remove('sidebar--open');
        if (mobileNavTrigger) mobileNavTrigger.classList.remove('mobile-nav-trigger--open');
    }

    if (mobileNavTrigger && sidebarEl) {
        mobileNavTrigger.addEventListener('click', function () {
            var open = sidebarEl.classList.toggle('sidebar--open');
            mobileNavTrigger.classList.toggle('mobile-nav-trigger--open', open);
        });
    }

    function activateSection(sectionKey) {
        var activeItem = null;
        document.querySelectorAll('.sidebar__item[data-section]').forEach(function (item) {
            var isActive = item.dataset.section === sectionKey;
            item.classList.toggle('active', isActive);
            if (isActive) activeItem = item;
        });
        document.querySelectorAll('.content > section').forEach(function (sec) {
            sec.classList.toggle('hidden', sec.id !== 'section-' + sectionKey);
        });

        if (mobileNavTriggerLabel && activeItem) {
            mobileNavTriggerLabel.textContent = activeItem.textContent.trim();
        }
        closeMobileNav();

        pushHash(sectionToHash(sectionKey));

        if (sectionKey === 'pedidos' && !_orders.loaded) loadOrders(true);
        if (sectionKey === 'dados-pessoais' && !_personalLoaded) loadPersonalData();
        if (sectionKey === 'favoritos') loadFavorites();
        if (sectionKey === 'endereco') {
            if (!_personalLoaded) loadPersonalData();
            showAddressList();
        }
        if (sectionKey === 'cashback') loadCashback();
        if (sectionKey === 'afiliado') loadAffiliate();
    }

    document.querySelectorAll('.sidebar__item[data-section]').forEach(function (item) {
        item.addEventListener('click', function () {
            activateSection(item.dataset.section);
        });
    });

    /* ═══════════════════════════════════════════════════════
       LOGOUT
    ═══════════════════════════════════════════════════════ */
    var sairBtn = el('js-sair');
    if (sairBtn) {
        var _sairClicked = false;
        sairBtn.addEventListener('click', async function () {
            if (_sairClicked) return;
            _sairClicked = true;
            try {
                await ApiWS.Calls.logout();
                ApiWS.User.clearSession();
                // Mantém o último e-mail conhecido pra pré-preencher formulários,
                // mas tira a trava pra o próximo login/identificação sobrescrever.
                if (ApiWS.CustomerEmail) ApiWS.CustomerEmail.demote();
                // O carrinho (orderIdKeepTC_B) fica associado ao cliente que estava
                // logado — sem isso ele sobrevive ao logoff e é reaproveitado pelo
                // próximo login/visitante nesse navegador, gerando conflito de ID
                // (mesmo padrão já usado em "Limpar Carrinho", wsapi3-checkout-cart).
                localStorage.removeItem('orderIdKeepTC_B');
                await ApiWS.Calls.cartStart();
            } catch (e) { }
            window.location.href = '/login';
        });
    }

    /* ═══════════════════════════════════════════════════════
       PEDIDOS
    ═══════════════════════════════════════════════════════ */
    var loadMoreBtn = el('js-load-more-btn');
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function () {
            _orders.page++;
            loadOrders(false);
        });
    }

    async function loadOrders(reset) {
        if (_orders.loading) return;
        _orders.loading = true;

        if (reset) {
            _orders.records = [];
            _orders.page = 1;
            _orders.loaded = false;
        }

        var listEl = el('js-order-list');
        var loadingEl = el('js-orders-loading');
        var emptyEl = el('js-orders-empty');
        var loadMoreEl = el('js-load-more');

        if (reset && listEl) listEl.innerHTML = '';
        if (loadingEl) loadingEl.classList.remove('hidden');
        if (emptyEl) emptyEl.classList.add('hidden');
        if (loadMoreEl) loadMoreEl.style.display = 'none';

        var params = { page: _orders.page, page_size: 10 };

        try {
            var data = await ApiWS.Calls._get('/user/data/order/list', params);
            if (loadingEl) loadingEl.classList.add('hidden');

            if (data && data.result === 'success') {
                _orders.total = data.total_records || 0;
                var incoming = data.records || [];
                _orders.records = reset ? incoming : _orders.records.concat(incoming);
                _orders.loaded = true;
                renderOrders(reset ? incoming : _orders.records);

                var shown = _orders.records.length;
                if (shown < _orders.total && loadMoreEl) {
                    loadMoreEl.style.display = 'flex';
                }
            } else {
                if (emptyEl) emptyEl.classList.remove('hidden');
            }
        } catch (e) {
            if (loadingEl) loadingEl.classList.add('hidden');
            if (emptyEl) {
                emptyEl.textContent = 'Erro ao carregar pedidos. Tente novamente.';
                emptyEl.classList.remove('hidden');
            }
        }
        _orders.loading = false;
    }

    function renderOrders(records) {
        var listEl = el('js-order-list');
        var emptyEl = el('js-orders-empty');
        if (!listEl) return;

        if (!records || records.length === 0) {
            listEl.innerHTML = '';
            if (emptyEl) emptyEl.classList.remove('hidden');
            return;
        }
        if (emptyEl) emptyEl.classList.add('hidden');

        var html = '';
        records.forEach(function (order) {
            // Estrutura real da API: campos aninhados
            var items = order.items || [];
            var firstItem = items[0] || {};
            var extraCount = items.length - 1;

            var imgSrc = firstItem.photo || '';
            var imgHtml = imgSrc
                ? '<img src="' + imgSrc + '" alt="' + (firstItem.name || '') + '" loading="lazy">'
                : '';

            var dates = order.dates || {};
            var badgeHtml = extraCount > 0 ? '<span class="order-item__badge">+' + extraCount + '</span>' : '';

            html += '<li class="order-item hover-border-card" data-order-number="' + (order.order_number || '') + '">' +
                '<div class="order-item__avatar"><div class="order-item__img">' + imgHtml + '</div>' + badgeHtml + '</div>' +
                '<div class="order-item__info">' +
                    '<div class="order-item__name">Pedido #' + (order.order_number || '') + '</div>' +
                '</div>' +
                '<div class="order-item__side">' +
                    (dates.placed_at ? '<span class="order-item__date">' + fmtDate(dates.placed_at) + '</span>' : '') +
                    '<span class="order-item__price">' + fmtPrice(order.total) + '</span>' +
                    '<span class="link">Ver detalhes</span>' +
                '</div>' +
                '</li>';
        });
        listEl.innerHTML += html;

        // delegação de clique para os itens recém inseridos
        listEl.querySelectorAll('.order-item[data-order-number]').forEach(function (li) {
            li.addEventListener('click', function () {
                var num = li.dataset.orderNumber;
                if (num) openOrderDetail(num);
            });
        });
    }

    /* ═══════════════════════════════════════════════════════
       CASHBACK
    ═══════════════════════════════════════════════════════ */
    async function initCashbackVisibility() {
        try {
            var info = await ApiWS.Calls._get('/store/info');
            var hasCashback = info && info.cashback === true;
            if (hasCashback) {
                var sidebarItem = el('sidebar-cashback');
                if (sidebarItem) sidebarItem.style.display = '';
            }
        } catch (e) {}
    }

    async function loadCashback() {
        var loadingEl = el('js-cashback-loading');
        var emptyEl = el('js-cashback-empty');
        var contentEl = el('js-cashback-content');

        if (loadingEl) loadingEl.classList.remove('hidden');
        if (emptyEl) emptyEl.classList.add('hidden');
        if (contentEl) contentEl.classList.add('hidden');

        try {
            var data = await ApiWS.Calls._get('/user/data/personal-info/cashback');
            if (loadingEl) loadingEl.classList.add('hidden');

            if (data && data.result === 'success' && data.record) {
                var r = data.record;

                setText('js-cb-balance', 'R$ ' + (r.balance || '0,00'));
                setText('js-cb-limit', 'Limite de uso de ' + (r.limit_percent || '10') + '% do valor pedido.');

                var couponText = r.coupon || '#cashback';
                setText('js-cb-coupon', couponText);

                var copyBtn = el('js-cb-copy');
                var copyLabel = el('js-cb-copy-label');
                if (copyBtn) {
                    copyBtn.onclick = function () {
                        navigator.clipboard.writeText(couponText).then(function () {
                            copyBtn.classList.add('cashback-copy-btn--copied');
                            if (copyLabel) copyLabel.textContent = 'Copiado!';
                            setTimeout(function () {
                                copyBtn.classList.remove('cashback-copy-btn--copied');
                                if (copyLabel) copyLabel.textContent = 'Copiar';
                            }, 2000);
                        });
                    };
                }

                var tbodyEl = el('js-cb-transactions');
                var theadEl = el('js-cb-thead');
                if (tbodyEl) {
                    var transactions = r.transactions || [];
                    if (theadEl) theadEl.classList.toggle('hidden', transactions.length === 0);
                    if (transactions.length === 0) {
                        tbodyEl.innerHTML = '<tr><td colspan="6" style="text-align:center;color:var(--color-muted);padding:24px 14px;">Nenhuma transação encontrada.</td></tr>';
                    } else {
                        var html = '';
                        transactions.forEach(function (t) {
                            var isDebit = t.type === 'debit';
                            var isExpired = t.expired === true;
                            var amountClass = isDebit ? 'cashback-table__debit' : 'cashback-table__credit';
                            var amountPrefix = isDebit ? '' : '+';

                            var validityHtml = t.expires_at ? fmtDate(t.expires_at) : '—';

                            var statusHtml;
                            if (!t.expires_at) {
                                statusHtml = '—';
                            } else if (isExpired) {
                                var expiredLabel = 'Expirado';
                                if (t.expired_amount) {
                                    expiredLabel += ' · R$ ' + t.expired_amount;
                                }
                                statusHtml = '<span class="cashback-badge cashback-badge--expired">' + expiredLabel + '</span>';
                            } else {
                                statusHtml = '<span class="cashback-badge cashback-badge--valid">Válido</span>';
                            }

                            html += '<tr>' +
                                '<td style="white-space:nowrap">' + fmtDateTime(t.date) + '</td>' +
                                '<td>' + (t.description || '') + '</td>' +
                                '<td class="' + amountClass + '" style="white-space:nowrap">' + amountPrefix + 'R$&nbsp;' + (t.amount || '0,00') + '</td>' +
                                '<td style="white-space:nowrap">R$&nbsp;' + (t.balance_after || '0,00') + '</td>' +
                                '<td style="white-space:nowrap">' + validityHtml + '</td>' +
                                '<td>' + statusHtml + '</td>' +
                                '</tr>';
                        });
                        tbodyEl.innerHTML = html;
                    }
                }

                if (contentEl) contentEl.classList.remove('hidden');
            } else {
                if (emptyEl) emptyEl.classList.remove('hidden');
            }
        } catch (e) {
            if (loadingEl) loadingEl.classList.add('hidden');
            if (emptyEl) {
                emptyEl.textContent = 'Erro ao carregar dados de cashback.';
                emptyEl.classList.remove('hidden');
            }
        }
    }

    /* ═══════════════════════════════════════════════════════
       AFILIADO
       /affiliate/link/view (link de divulgação), /affiliate/commission/summary
       (totais recebido / a receber) e /affiliate/order/list (pedidos feitos
       pelo link, paginado). O menu só aparece com record.affiliate === true
       no personal-info/view (ver loadPersonalData).
    ═══════════════════════════════════════════════════════ */
    var COPY_ICON_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<rect x="9" y="9" width="13" height="13" rx="1" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>' +
        '<path d="M5 15H4C3.44772 15 3 14.5523 3 14V4C3 3.44772 3.44772 3 4 3H14C14.5523 3 15 3.44772 15 4V5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
        '</svg>';

    function fmtOrdersCount(n) {
        n = Number(n || 0);
        return n + (n === 1 ? ' pedido' : ' pedidos');
    }

    function renderAffiliateLinks(data) {
        var cardEl = el('js-af-link-card');
        var linksEl = el('js-af-links');
        if (!cardEl || !linksEl) return;

        var links = [];
        if (data && data.result === 'success') {
            links = (data.records && data.records.length) ? data.records : (data.record ? [data.record] : []);
        }
        links = links.filter(function (l) { return l && l.url && l.active !== false; });

        cardEl.style.display = links.length ? '' : 'none';
        linksEl.innerHTML = links.map(function (l) {
            return '<div class="cashback-card__coupon-row">' +
                '<span class="affiliate-link-url">' + escHtml(l.url) + '</span>' +
                '<button type="button" class="cashback-copy-btn" title="Copiar link" data-af-copy="' + escHtml(l.url) + '">' +
                    COPY_ICON_SVG + '<span class="cashback-copy-btn__label">Copiar</span>' +
                '</button>' +
                '</div>';
        }).join('');

        linksEl.querySelectorAll('[data-af-copy]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var labelEl = btn.querySelector('.cashback-copy-btn__label');
                navigator.clipboard.writeText(btn.getAttribute('data-af-copy')).then(function () {
                    btn.classList.add('cashback-copy-btn--copied');
                    if (labelEl) labelEl.textContent = 'Copiado!';
                    setTimeout(function () {
                        btn.classList.remove('cashback-copy-btn--copied');
                        if (labelEl) labelEl.textContent = 'Copiar';
                    }, 2000);
                });
            });
        });
    }

    function renderAffiliateSummary(data) {
        var r = (data && data.result === 'success' && data.record) || {};
        var toReceive = r.to_receive || {};
        var received = r.received || {};
        setText('js-af-to-receive', fmtPrice(toReceive.amount));
        setText('js-af-to-receive-orders', fmtOrdersCount(toReceive.orders));
        setText('js-af-received', fmtPrice(received.amount));
        setText('js-af-received-orders', fmtOrdersCount(received.orders));
    }

    function affiliateOrderRowsHtml(records) {
        var html = '';
        records.forEach(function (o) {
            var status = o.status || {};
            var commission = o.commission_status || {};
            var badgeClass = commission.id === 'paid' ? 'cashback-badge--valid' : 'cashback-badge--pending';
            html += '<tr>' +
                '<td style="white-space:nowrap">#' + escHtml(o.order_number) + '</td>' +
                '<td style="white-space:nowrap">' + fmtDateTime(o.date) + '</td>' +
                '<td>' + escHtml(o.buyer_first_name) + '</td>' +
                '<td style="white-space:nowrap">' + fmtPrice(o.products_total).replace(' ', '&nbsp;') + '</td>' +
                '<td>' + escHtml(status.label) + '</td>' +
                '<td>' + (commission.label ? '<span class="cashback-badge ' + badgeClass + '">' + escHtml(commission.label) + '</span>' : '—') + '</td>' +
                '</tr>';
        });
        return html;
    }

    async function loadAffiliateOrders(reset) {
        if (_affOrders.loading) return;
        _affOrders.loading = true;

        var tbodyEl = el('js-af-orders');
        var theadEl = el('js-af-thead');
        var loadMoreEl = el('js-af-load-more');

        if (reset) {
            _affOrders.page = 1;
            _affOrders.total = 0;
            _affOrders.shown = 0;
        }
        if (loadMoreEl) loadMoreEl.style.display = 'none';

        var emptyRow = function (text) {
            return '<tr><td colspan="6" style="text-align:center;color:var(--color-muted);padding:24px 14px;">' + text + '</td></tr>';
        };

        try {
            var data = await ApiWS.Calls._get('/affiliate/order/list', { page: _affOrders.page, page_size: 10 });
            var ok = data && data.result === 'success';
            var records = (ok && data.records) || [];

            if (ok) _affOrders.total = data.total_records || 0;
            _affOrders.shown += records.length;

            if (tbodyEl) {
                if (reset) {
                    if (theadEl) theadEl.classList.toggle('hidden', records.length === 0);
                    tbodyEl.innerHTML = records.length
                        ? affiliateOrderRowsHtml(records)
                        : emptyRow(ok ? 'Nenhum pedido feito pelo seu link ainda.' : 'Não foi possível carregar os pedidos.');
                } else {
                    tbodyEl.insertAdjacentHTML('beforeend', affiliateOrderRowsHtml(records));
                }
            }

            if (loadMoreEl && records.length && _affOrders.shown < _affOrders.total) {
                loadMoreEl.style.display = 'flex';
            }
        } catch (e) {
            if (reset && tbodyEl) {
                if (theadEl) theadEl.classList.add('hidden');
                tbodyEl.innerHTML = emptyRow('Não foi possível carregar os pedidos.');
            } else if (loadMoreEl) {
                // falha ao paginar: volta a página e mantém o botão pra tentar de novo
                _affOrders.page--;
                loadMoreEl.style.display = 'flex';
            }
        }
        _affOrders.loading = false;
    }

    var affLoadMoreBtn = el('js-af-load-more-btn');
    if (affLoadMoreBtn) {
        affLoadMoreBtn.addEventListener('click', function () {
            if (_affOrders.loading) return;
            _affOrders.page++;
            loadAffiliateOrders(false);
        });
    }

    async function loadAffiliate() {
        var loadingEl = el('js-affiliate-loading');
        var emptyEl = el('js-affiliate-empty');
        var contentEl = el('js-affiliate-content');

        if (loadingEl) loadingEl.classList.remove('hidden');
        if (emptyEl) emptyEl.classList.add('hidden');
        if (contentEl) contentEl.classList.add('hidden');

        // Cada chamada falha sozinha (catch → null) — o link continua aparecendo
        // mesmo se o resumo falhar, e vice-versa.
        var safe = function (p) { return p.catch(function () { return null; }); };
        var results = await Promise.all([
            safe(ApiWS.Calls._get('/affiliate/link/view')),
            safe(ApiWS.Calls._get('/affiliate/commission/summary')),
            loadAffiliateOrders(true)
        ]);
        var linkData = results[0];
        var summaryData = results[1];

        if (loadingEl) loadingEl.classList.add('hidden');

        var linkOk = linkData && linkData.result === 'success';
        var summaryOk = summaryData && summaryData.result === 'success';
        if (!linkOk && !summaryOk) {
            if (emptyEl) {
                emptyEl.textContent = (linkData && linkData.message) || (summaryData && summaryData.message) || 'Erro ao carregar dados de afiliado.';
                emptyEl.classList.remove('hidden');
            }
            return;
        }

        renderAffiliateLinks(linkData);
        renderAffiliateSummary(summaryData);
        if (contentEl) contentEl.classList.remove('hidden');
    }

    /* ═══════════════════════════════════════════════════════
       DETALHE DO PEDIDO
    ═══════════════════════════════════════════════════════ */
    function showOrderDetailSection() {
        // esconde todas as seções e mostra o detalhe
        document.querySelectorAll('.content > section').forEach(function (sec) {
            sec.classList.toggle('hidden', sec.id !== 'section-pedido-detalhe');
        });
    }

    // /user/data/order/view traz o payload completo (endereço, destinatário, prazo, timeline
    // com estado por etapa, nota fiscal com link) — o /user/data/order/list usado na listagem
    // só tem um resumo raso, então o detalhe sempre busca de novo por número.
    async function openOrderDetail(orderNumber) {
        showOrderDetailSection();

        var loadingEl = el('js-od-loading');
        var errorEl = el('js-od-error');
        var contentEl = el('js-od-content');

        if (contentEl) contentEl.classList.add('hidden');
        if (errorEl) errorEl.classList.add('hidden');
        if (loadingEl) loadingEl.classList.remove('hidden');

        setText('js-od-title', 'Pedido #' + orderNumber);
        setText('js-od-status', '');

        try {
            var data = await ApiWS.Calls._get('/user/data/order/view', { number: orderNumber });
            if (loadingEl) loadingEl.classList.add('hidden');

            if (data && data.result === 'success' && data.record) {
                populateOrderDetail(data.record);
                if (contentEl) contentEl.classList.remove('hidden');
            } else if (errorEl) {
                errorEl.classList.remove('hidden');
            }
        } catch (e) {
            if (loadingEl) loadingEl.classList.add('hidden');
            if (errorEl) errorEl.classList.remove('hidden');
        }
    }

    function setText(id, text) {
        var el2 = el(id);
        if (el2) el2.textContent = text || '';
    }

    function setRowVisible(rowId, visible) {
        var row = el(rowId);
        if (row) row.style.display = visible ? '' : 'none';
    }

    function setHref(id, href) {
        var el2 = el(id);
        if (!el2) return;
        if (href) {
            el2.href = href;
            el2.style.display = '';
        } else {
            el2.style.display = 'none';
        }
    }

    // /user/data/order/view traz payment_info (mesmo formato do /cart/checkout/finish)
    // com os dados pra o cliente efetivar o pagamento — só faz sentido mostrar esse
    // bloco quando o pedido ainda está "Aguardando pagamento" (status.id "1" na API)
    // e o meio de pagamento permite ação (boleto/pix/depósito); cartão/entrega/outros
    // não têm ação pendente do lado do cliente.
    function renderPaymentPendingBlock(order) {
        var row = el('js-od-payment-pending-row');
        var contentEl = el('js-od-payment-pending-content');
        if (!row || !contentEl) return;

        var status = order.status || {};
        var paymentInfo = order.payment_info || null;
        var eligibleTypes = ['boleto', 'pix', 'bank_deposit'];
        var isAwaitingPayment = String(status.id) === '1';

        if (!isAwaitingPayment || !paymentInfo || eligibleTypes.indexOf(paymentInfo.type) === -1) {
            row.classList.add('hidden');
            contentEl.innerHTML = '';
            return;
        }

        // Boleto e depósito abrem com o mesmo aviso, pedido explicitamente —
        // o cliente pode estar revendo um pedido já pago, então deixamos claro que
        // a ação só vale "caso ainda não tenha feito o pagamento". O Pix não tem
        // texto: só o QR Code e o código.
        var intro = 'Caso ainda não tenha feito o pagamento, ';

        var html = '';
        if (paymentInfo.type === 'boleto') {
            html += '<p class="info-text">' + intro + 'acesse o boleto abaixo para efetuar o pagamento.</p>';
            if (paymentInfo.boleto_url) {
                html += '<a class="btn btn--dark" href="' + paymentInfo.boleto_url + '" target="_blank" rel="noopener">Ver boleto</a>';
            }
        } else if (paymentInfo.type === 'pix') {
            html += '<div class="pix-pay-block">';
            if (paymentInfo.pix_qr_code) {
                // pix_qr_code vem ora como URL, ora como PNG cru em base64 (sem
                // prefixo "data:"), dependendo do gateway (ex.: Mercado Pago) —
                // mesmo ajuste do wsapi3-checkout-final-page.
                var pixQrSrc = paymentInfo.pix_qr_code;
                if (!/^(https?:|data:)/i.test(pixQrSrc)) pixQrSrc = 'data:image/png;base64,' + pixQrSrc;
                html += '<img class="pix-pay-qr" src="' + pixQrSrc + '" alt="QR Code Pix">';
            }
            if (paymentInfo.pix_key) {
                // Mesmo padrão visual do campo de CEP + botão "Calcular" do frete
                // (.pix-copy-form espelha .cart-drawer-frete-form): input somente
                // leitura + botão embutido, um único grupo com borda só na volta.
                html += '<div class="pix-copy-form">' +
                    '<input type="text" id="js-od-pix-key" readonly value="' + paymentInfo.pix_key + '">' +
                    '<button type="button" id="js-od-pix-copy">Copiar</button>' +
                '</div>';
            } else {
                html += '<p class="field-hint">Código Pix indisponível no momento.</p>';
            }
            html += '</div>';
        } else if (paymentInfo.type === 'bank_deposit') {
            html += '<p class="info-text">' + intro + 'siga as instruções abaixo para efetuar o pagamento via depósito bancário.</p>';
            if (paymentInfo.instructions_1) html += '<p class="info-text">' + nl2br(paymentInfo.instructions_1) + '</p>';
            if (paymentInfo.instructions_2) html += '<p class="info-text">' + nl2br(paymentInfo.instructions_2) + '</p>';
        }

        contentEl.innerHTML = html;
        row.classList.remove('hidden');

        var pixCopyBtn = el('js-od-pix-copy');
        if (pixCopyBtn) {
            pixCopyBtn.addEventListener('click', function () {
                var origLabel = pixCopyBtn.textContent;
                navigator.clipboard.writeText(paymentInfo.pix_key || '').then(function () {
                    pixCopyBtn.textContent = 'Copiado!';
                    setTimeout(function () { pixCopyBtn.textContent = origLabel; }, 2000);
                });
            });
        }
    }

    function populateOrderDetail(order) {
        var status = order.status || {};
        var timeline = order.timeline || [];
        var payment = order.payment || {};
        var shipping = order.shipping || {};
        var address = shipping.address || {};
        var summary = order.summary || {};
        var invoice = order.invoice || null;
        var items = order.items || [];

        setText('js-od-title', 'Pedido #' + (order.order_number || ''));

        // ── Refazer pedido — link de carrinho compartilhado a partir do "tc" do pedido,
        // mesmo formato usado no checkout/cart-drawer (?share_cart=...)
        var reorderLink = el('js-od-reorder');
        if (reorderLink) {
            reorderLink.href = buildCartShareLink(order.tc) || '/carrinho';
        }

        // ── Status (sempre a mesma cor fixa — azul de link, igual .order-detail-status no CSS)
        var statusEl = el('js-od-status');
        if (statusEl) {
            statusEl.textContent = status.label || '';
        }

        // ── Pagamento pendente (boleto/Pix/depósito aguardando pagamento)
        renderPaymentPendingBlock(order);

        // ── Itens
        var itemsEl = el('js-od-items');
        if (itemsEl) {
            var itemsHtml = '';
            items.forEach(function (item) {
                var unitPrice = item.unit_price || 0;
                var qty = item.quantity || 1;
                var imgHtml = item.photo
                    ? '<img src="' + item.photo + '" alt="' + (item.name || '') + '" loading="lazy">'
                    : '';
                itemsHtml += '<li class="order-detail-item">' +
                    '<div class="order-detail-item__img">' + imgHtml + '</div>' +
                    '<div>' +
                        '<div class="order-detail-item__name">' + (item.name || '') + '</div>' +
                        '<div class="order-detail-item__meta">' +
                            (item.sku ? '<span>SKU: ' + item.sku + '</span>' : '') +
                            '<span>Qtd.: ' + qty + '</span>' +
                            (item.gift_wrap ? '<span>Embrulhado para presente: Sim</span>' : '') +
                        '</div>' +
                    '</div>' +
                    '<div class="order-detail-item__price-col">' +
                        '<div class="order-detail-item__unit">' + fmtPrice(unitPrice) + ' /un</div>' +
                        '<div class="order-detail-item__total">' + fmtPrice(unitPrice * qty) + '</div>' +
                    '</div>' +
                    '</li>';
            });
            itemsEl.innerHTML = itemsHtml;
        }

        // ── Resumo financeiro (vem pronto de summary — antes o subtotal era recalculado somando os itens)
        setText('js-od-subtotal', fmtPrice(summary.subtotal));
        var shippingCost = summary.shipping_cost || 0;
        setText('js-od-shipping-cost', shippingCost > 0 ? fmtPrice(shippingCost) : 'Grátis');
        setRowVisible('js-od-discount-row', !!summary.discount);
        if (summary.discount) setText('js-od-discount', '- ' + fmtPrice(summary.discount));
        setText('js-od-total', fmtPrice(summary.total));

        // ── Cupom / vale-compra / cashback usado no pedido (record.coupon, null sem
        // cupom). `label` já vem pronto da API ("10%", "R$ 20,00", "Frete grátis",
        // valor usado no cashback). O valor em R$ descontado já está em "Desconto".
        var coupon = order.coupon || null;
        setRowVisible('js-od-coupon-row', !!coupon);
        if (coupon) {
            var couponKind = { coupon: 'Cupom', voucher: 'Vale-compra', cashback: 'Cashback' }[coupon.kind] || 'Cupom';
            var couponCode = coupon.kind === 'cashback' ? '' : String(coupon.code || '');
            setText('js-od-coupon-title', couponKind + (couponCode ? ' ' + couponCode : ''));
            var couponTitleEl = el('js-od-coupon-title');
            if (couponTitleEl && coupon.name) couponTitleEl.title = coupon.name;
            var couponValue = coupon.label
                || (coupon.discount_type === 'P' ? coupon.value + '%'
                    : coupon.discount_type === 'F' ? 'Frete grátis'
                    : fmtPrice(coupon.amount_used != null ? coupon.amount_used : coupon.value));
            setText('js-od-coupon', couponValue);
        }

        // ── Entrega (linhas soltas, sem label — o método já leva o prazo embutido)
        var shippingMethodLine = shipping.method || '—';
        if (shipping.delivery_time_days) shippingMethodLine += ' - ' + shipping.delivery_time_days + ' dias úteis';
        setText('js-od-shipping-method', shippingMethodLine);

        setRowVisible('js-od-delivery-estimate-row', !!shipping.estimated_delivery_date);
        setText('js-od-delivery-estimate', shipping.estimated_delivery_date ? 'Entrega prevista para ' + fmtDate(shipping.estimated_delivery_date) : '');

        setRowVisible('js-od-recipient-row', !!shipping.recipient);
        setText('js-od-recipient', shipping.recipient || '');

        var trackingRow = el('js-od-tracking-row');
        if (shipping.tracking_code) {
            setText('js-od-tracking-code', shipping.tracking_code);
            if (trackingRow) trackingRow.style.display = '';
        } else {
            if (trackingRow) trackingRow.style.display = 'none';
        }

        // ── Endereço de entrega
        var hasAddress = !!(address.address || address.zipcode);
        var addressBlock = el('js-od-address-block');
        if (addressBlock) addressBlock.style.display = hasAddress ? '' : 'none';
        var addressEl = el('js-od-address');
        if (addressEl && hasAddress) {
            var line1 = (address.address || '') +
                (address.number ? ', ' + address.number : '') +
                (address.complement ? ' - ' + address.complement : '');
            addressEl.innerHTML =
                (address.zipcode ? '<div>' + address.zipcode + '</div>' : '') +
                (line1 ? '<div>' + line1 + '</div>' : '') +
                (address.neighborhood ? '<div>' + address.neighborhood + '</div>' : '') +
                '<div>' + (address.city || '') + (address.state ? ' - ' + address.state : '') + '</div>';
        }

        // ── Pagamento (linha única com bandeira/final do cartão embutidos, sem label)
        var paymentMethodLine = payment.method || payment.category || '—';
        var cardParts = [];
        if (payment.brand) cardParts.push(payment.brand);
        if (payment.card_last4) cardParts.push('com final ' + payment.card_last4);
        if (cardParts.length) paymentMethodLine += ' - ' + cardParts.join(' ');
        setText('js-od-payment-method', paymentMethodLine);

        var installmentsRow = el('js-od-installments-row');
        if (payment.installments && payment.installments > 1) {
            var installmentText = payment.installments + 'x' +
                (payment.interest_free ? ' sem juros' : '') +
                (payment.installment_value ? ' de ' + fmtPrice(payment.installment_value) : '');
            setText('js-od-installments', installmentText);
            if (installmentsRow) installmentsRow.style.display = '';
        } else {
            if (installmentsRow) installmentsRow.style.display = 'none';
        }

        // ── Timeline — vem pronta da API (id/label/date/completed), sem passos fixos no client
        var timelineEl = el('js-od-timeline');
        if (timelineEl) {
            var tlHtml = '';
            timeline.forEach(function (ev) {
                var done = !!ev.completed;
                tlHtml += '<div class="order-detail-timeline-item' + (done ? ' order-detail-timeline-item--done' : '') + '">' +
                    '<div class="order-detail-timeline-dot' + (done ? ' order-detail-timeline-dot--done' : '') + '"></div>' +
                    '<div class="order-detail-timeline-label">' +
                        '<strong>' + (ev.label || '') + '</strong>' +
                        (ev.date ? fmtDateTime(ev.date) : '') +
                    '</div>' +
                    '</div>';
            });
            timelineEl.innerHTML = tlHtml;
        }

        // ── Botões de ação
        setHref('js-od-tracking-btn', shipping.tracking_url || null);
        setHref('js-od-invoice-btn', (invoice && invoice.link) ? invoice.link : null);
    }

    // botão Voltar
    var orderDetailBackBtn = el('js-order-detail-back');
    if (orderDetailBackBtn) {
        orderDetailBackBtn.addEventListener('click', function () {
            activateSection('pedidos');
        });
    }

    /* ═══════════════════════════════════════════════════════
       DADOS PESSOAIS + ENDEREÇOS (load compartilhado)
    ═══════════════════════════════════════════════════════ */
    // Chamada única compartilhada: o init (visibilidade do menu Afiliado) e as
    // seções Meus dados/Endereços pedem ao mesmo tempo. Falhou → libera nova tentativa.
    function loadPersonalData() {
        if (!_personalPromise) {
            _personalPromise = fetchPersonalData().then(function () {
                if (!_personalLoaded) _personalPromise = null;
            });
        }
        return _personalPromise;
    }

    async function fetchPersonalData() {
        try {
            var data = await ApiWS.Calls._get('/user/data/personal-info/view');
            if (data && data.result === 'success' && data.record) {
                var r = data.record;
                _personalLoaded = true;

                // Afiliado: libera o item do menu
                _isAffiliate = r.affiliate === true;
                var affiliateItem = el('sidebar-afiliado');
                if (affiliateItem) affiliateItem.style.display = _isAffiliate ? '' : 'none';

                // Preenche campos de dados pessoais
                setValue('js-pdata-name', r.name || '');
                setValue('js-pdata-cpf', r.cpf_cnpj || '');
                setValue('js-pdata-mobile', r.mobile || '');
                setValue('js-pdata-phone', r.phone || '');
                setValue('js-pdata-birth', fmtDateToInput(r.birth_date));
                setSelect('js-pdata-gender', r.gender || '');

                // Newsletter
                _personalLoaded = true;
                var newsletterBlock = el('js-newsletter-block');
                if (newsletterBlock) {
                    if (r.newsletter) {
                        newsletterBlock.style.display = '';
                    } else {
                        var nText = el('js-newsletter-text');
                        if (nText) nText.textContent = 'Você não está inscrito na newsletter.';
                        var nBtn = el('js-newsletter-btn');
                        if (nBtn) nBtn.style.display = 'none';
                    }
                }

                // Endereços
                _addresses = r.addresses || [];
                renderAddressCards();
            }
        } catch (e) { }
    }

    function setValue(id, val) {
        var inp = el(id);
        if (inp) inp.value = val || '';
    }

    function setSelect(id, val) {
        var sel = el(id);
        if (!sel) return;
        for (var i = 0; i < sel.options.length; i++) {
            if (sel.options[i].value === val) { sel.selectedIndex = i; return; }
        }
    }

    /* ─── Salvar dados pessoais ─── */
    var pdataSaveBtn = el('js-pdata-save-btn');
    if (pdataSaveBtn) {
        pdataSaveBtn.addEventListener('click', async function () {
            clearMsg('js-pdata-msg');
            setLoading('js-pdata-save-btn', true);

            var birthRaw = (el('js-pdata-birth') || {}).value || '';
            var body = {
                name: (el('js-pdata-name') || {}).value || '',
                cpf_cnpj: onlyDigits((el('js-pdata-cpf') || {}).value || ''),
                mobile: onlyDigits((el('js-pdata-mobile') || {}).value || ''),
                phone: onlyDigits((el('js-pdata-phone') || {}).value || ''),
                birth_date: parseDateInput(birthRaw),
                gender: (el('js-pdata-gender') || {}).value || ''
            };

            // Remove campos vazios opcionais para não disparar validação desnecessária
            if (!body.phone) delete body.phone;
            if (!body.gender) delete body.gender;
            if (!body.birth_date) delete body.birth_date;
            if (!body.cpf_cnpj) delete body.cpf_cnpj;

            try {
                var data = await ApiWS.Calls._post('/user/data/personal-info/save', body);
                if (data && data.result === 'success') {
                    setMsg('js-pdata-msg', 'Dados atualizados com sucesso.', 'success');
                } else {
                    setMsg('js-pdata-msg', (data && data.message) || 'Erro ao salvar dados.', 'error');
                }
            } catch (e) {
                setMsg('js-pdata-msg', 'Erro de conexão. Tente novamente.', 'error');
            }
            setLoading('js-pdata-save-btn', false);
        });
    }

    /* ═══════════════════════════════════════════════════════
       ALTERAR E-MAIL
    ═══════════════════════════════════════════════════════ */
    var _emailPending = '';

    function showEmailStep(step) {
        var s1 = el('js-email-step1');
        var s2 = el('js-email-step2');
        if (s1) s1.classList.toggle('hidden', step !== 1);
        if (s2) s2.classList.toggle('hidden', step !== 2);
    }

    var emailChangeBtn = el('js-email-change-btn');
    if (emailChangeBtn) {
        emailChangeBtn.addEventListener('click', async function () {
            clearMsg('js-email-msg');
            var newEmail = ((el('js-email-new-input') || {}).value || '').trim();
            var confirmEmail = ((el('js-email-confirm-input') || {}).value || '').trim();
            if (!newEmail) {
                setMsg('js-email-msg', 'Informe o novo e-mail.', 'error');
                return;
            }
            if (newEmail !== confirmEmail) {
                setMsg('js-email-msg', 'Os e-mails não coincidem.', 'error');
                return;
            }
            setLoading('js-email-change-btn', true);
            try {
                var data = await ApiWS.Calls._post('/user/data/email/change', { new_email: newEmail });
                if (data && data.result === 'success') {
                    _emailPending = newEmail;
                    var label = el('js-email-step2-label');
                    if (label) label.textContent = 'Digite o código enviado para ' + newEmail + ':';
                    setValue('js-email-code-input', '');
                    showEmailStep(2);
                    setMsg('js-email-msg', 'Código enviado! Verifique seu e-mail.', 'success');
                } else {
                    setMsg('js-email-msg', (data && data.message) || 'Não foi possível enviar o código.', 'error');
                }
            } catch (e) {
                setMsg('js-email-msg', 'Erro de conexão. Tente novamente.', 'error');
            }
            setLoading('js-email-change-btn', false);
        });
    }

    var emailConfirmBtn = el('js-email-confirm-btn');
    if (emailConfirmBtn) {
        emailConfirmBtn.addEventListener('click', async function () {
            clearMsg('js-email-msg');
            var code = ((el('js-email-code-input') || {}).value || '').trim();
            if (!code) {
                setMsg('js-email-msg', 'Informe o código recebido por e-mail.', 'error');
                return;
            }
            setLoading('js-email-confirm-btn', true);
            try {
                var data = await ApiWS.Calls._post('/user/data/email/change-confirm', {
                    new_email: _emailPending,
                    code: code
                });
                if (data && data.result === 'success') {
                    _emailPending = '';
                    showEmailStep(1);
                    setValue('js-email-new-input', '');
                    setValue('js-email-confirm-input', '');
                    setMsg('js-email-msg', 'E-mail alterado com sucesso!', 'success');
                } else {
                    setMsg('js-email-msg', (data && data.message) || 'Código inválido ou expirado.', 'error');
                }
            } catch (e) {
                setMsg('js-email-msg', 'Erro de conexão. Tente novamente.', 'error');
            }
            setLoading('js-email-confirm-btn', false);
        });
    }

    var emailCancelBtn = el('js-email-cancel-btn');
    if (emailCancelBtn) {
        emailCancelBtn.addEventListener('click', function () {
            _emailPending = '';
            showEmailStep(1);
            clearMsg('js-email-msg');
        });
    }

    /* ═══════════════════════════════════════════════════════
       ALTERAR SENHA (via forgot-password + código)
    ═══════════════════════════════════════════════════════ */
    function showPwdStep(step) {
        var s1 = el('js-pwd-step1');
        var s2 = el('js-pwd-step2');
        if (s1) s1.classList.toggle('hidden', step !== 1);
        if (s2) s2.classList.toggle('hidden', step !== 2);
    }

    // Checklist de força da senha
    var pwdNewInput = el('js-pwd-new');
    if (pwdNewInput) {
        pwdNewInput.addEventListener('input', function () {
            var pwd = pwdNewInput.value;
            var strengthEl = el('js-pwd-strength');
            if (strengthEl) strengthEl.classList.toggle('pwd-strength--hidden', pwd.length === 0);
            var rules = {
                upper: /[A-Z]/.test(pwd),
                lower: /[a-z]/.test(pwd),
                special: /[^A-Za-z0-9]/.test(pwd),
                number: /[0-9]/.test(pwd),
                length: pwd.length >= 8
            };
            var metCount = 0;
            Object.keys(rules).forEach(function (rule) {
                if (rules[rule]) metCount++;
                var item = document.querySelector('.pwd-strength__item[data-rule="' + rule + '"]');
                if (item) item.classList.toggle('pwd-strength__item--done', rules[rule]);
            });
            var segs = document.querySelectorAll('.pwd-strength__seg');
            segs.forEach(function (seg, i) {
                seg.classList.toggle('pwd-strength__seg--filled', i < metCount);
            });
        });
    }

    var pwdChangeBtn = el('js-pwd-change-btn');
    if (pwdChangeBtn) {
        pwdChangeBtn.addEventListener('click', async function () {
            clearMsg('js-pwd-msg');
            var newPwd = ((el('js-pwd-new') || {}).value || '');
            var confirmPwd = ((el('js-pwd-confirm') || {}).value || '');

            if (!newPwd) {
                setMsg('js-pwd-msg', 'Informe a nova senha.', 'error');
                return;
            }
            if (newPwd.length < 8) {
                setMsg('js-pwd-msg', 'A senha deve ter no mínimo 8 caracteres.', 'error');
                return;
            }
            if (newPwd !== confirmPwd) {
                setMsg('js-pwd-msg', 'As senhas não coincidem.', 'error');
                return;
            }

            if (!_session || !_session.email) {
                setMsg('js-pwd-msg', 'Sessão inválida. Faça login novamente.', 'error');
                return;
            }

            setLoading('js-pwd-change-btn', true);
            try {
                // Envia código para o e-mail do usuário via forgot-password
                await ApiWS.Calls.forgotPassword(_session.email);
                _pwdNewPassword = newPwd;
                setValue('js-pwd-code-input', '');
                showPwdStep(2);
                setMsg('js-pwd-msg', 'Código enviado para ' + _session.email + '. Verifique seu e-mail.', 'success');
            } catch (e) {
                setMsg('js-pwd-msg', 'Erro de conexão. Tente novamente.', 'error');
            }
            setLoading('js-pwd-change-btn', false);
        });
    }

    var pwdCodeBtn = el('js-pwd-code-btn');
    if (pwdCodeBtn) {
        pwdCodeBtn.addEventListener('click', async function () {
            clearMsg('js-pwd-msg');
            var code = ((el('js-pwd-code-input') || {}).value || '').trim();
            if (!code) {
                setMsg('js-pwd-msg', 'Informe o código recebido por e-mail.', 'error');
                return;
            }
            if (!_session || !_session.email) {
                setMsg('js-pwd-msg', 'Sessão inválida. Faça login novamente.', 'error');
                return;
            }

            setLoading('js-pwd-code-btn', true);
            try {
                // Verifica código
                var verifyData = await ApiWS.Calls.forgotPasswordVerify(_session.email, code);
                if (!verifyData || verifyData.result !== 'success' || !verifyData.record || !verifyData.record.reset_token) {
                    setMsg('js-pwd-msg', (verifyData && verifyData.message) || 'Código inválido ou expirado.', 'error');
                    setLoading('js-pwd-code-btn', false);
                    return;
                }

                // Redefine senha com o token
                var resetData = await ApiWS.Calls.resetPassword(verifyData.record.reset_token, _pwdNewPassword);
                if (resetData && resetData.result === 'success') {
                    _pwdNewPassword = '';
                    showPwdStep(1);
                    setValue('js-pwd-new', '');
                    setValue('js-pwd-confirm', '');
                    if (pwdNewInput) pwdNewInput.dispatchEvent(new Event('input'));
                    setMsg('js-pwd-msg', 'Senha alterada com sucesso!', 'success');
                } else {
                    setMsg('js-pwd-msg', (resetData && resetData.message) || 'Não foi possível alterar a senha.', 'error');
                }
            } catch (e) {
                setMsg('js-pwd-msg', 'Erro de conexão. Tente novamente.', 'error');
            }
            setLoading('js-pwd-code-btn', false);
        });
    }

    var pwdCancelBtn = el('js-pwd-cancel-btn');
    if (pwdCancelBtn) {
        pwdCancelBtn.addEventListener('click', function () {
            _pwdNewPassword = '';
            showPwdStep(1);
            clearMsg('js-pwd-msg');
        });
    }

    /* ═══════════════════════════════════════════════════════
       NEWSLETTER
    ═══════════════════════════════════════════════════════ */
    var newsletterBtn = el('js-newsletter-btn');
    if (newsletterBtn) {
        newsletterBtn.addEventListener('click', async function () {
            clearMsg('js-newsletter-msg');
            if (!confirm('Deseja cancelar sua inscrição na newsletter?')) return;
            setLoading('js-newsletter-btn', true);
            try {
                var data = await ApiWS.Calls._post('/user/data/email/newsletter-remove', {});
                if (data && data.result === 'success') {
                    setMsg('js-newsletter-msg', 'Inscrição cancelada com sucesso.', 'success');
                    newsletterBtn.style.display = 'none';
                    var nText = el('js-newsletter-text');
                    if (nText) nText.textContent = 'Você não está inscrito na newsletter.';
                } else {
                    setMsg('js-newsletter-msg', (data && data.message) || 'Erro ao cancelar inscrição.', 'error');
                }
            } catch (e) {
                setMsg('js-newsletter-msg', 'Erro de conexão. Tente novamente.', 'error');
            }
            setLoading('js-newsletter-btn', false);
        });
    }

    /* ═══════════════════════════════════════════════════════
       APAGAR CONTA
    ═══════════════════════════════════════════════════════ */
    var deleteAccountBtn = el('js-delete-account-btn');
    if (deleteAccountBtn) {
        deleteAccountBtn.addEventListener('click', function () {
            alert('Para apagar sua conta, entre em contato com o suporte da loja.');
        });
    }

    /* ═══════════════════════════════════════════════════════
       FAVORITOS
    ═══════════════════════════════════════════════════════ */
    var TRASH_ICON_SVG = '<span data-wsjs-icon="delete"></span>';

    async function loadFavorites() {
        var gridEl = el('js-fav-grid');
        var loadingEl = el('js-fav-loading');
        var emptyEl = el('js-fav-empty');

        if (!gridEl) return;
        gridEl.innerHTML = '';
        if (loadingEl) loadingEl.classList.remove('hidden');
        if (emptyEl) emptyEl.classList.add('hidden');

        try {
            var data = await ApiWS.Calls._get('/product/list', { source: 'favorites' });
            if (loadingEl) loadingEl.classList.add('hidden');

            var records = (data && data.records) || [];

            if (ApiWS.debug && records.length > 0) {
                console.log('[ws-customer-area-page] favorites first record:', JSON.stringify(records[0]));
            }

            if (records.length === 0) {
                if (emptyEl) emptyEl.classList.remove('hidden');
                return;
            }

            var html = '';
            records.forEach(function (p) {
                // Suporte a formato raw v3 (images.primary / prices.regular) e legado (fotos[] / precos.preco)
                var name = p.name || p.nome || '';
                var url = p.url || (p.links && p.links.ver_produto) || '#';

                var imgSrc = (p.images && p.images.primary) || '';
                if (!imgSrc && p.fotos) {
                    var f0 = p.fotos[0];
                    imgSrc = typeof f0 === 'string' ? f0 : (f0 && (f0.normal || f0.thumb)) || '';
                }
                var imgHtml = imgSrc
                    ? '<img src="' + imgSrc + '" alt="' + name + '" loading="lazy">'
                    : '';

                var prices = p.prices || {};
                var precos = p.precos || {};
                var regularPrice = prices.regular || precos.preco || 0;
                var price = prices.promotional || prices.regular
                         || precos.preco_promocao || precos.preco || 0;
                var hasDiscount = regularPrice > 0 && price > 0 && price < regularPrice;

                html += '<div class="fav-item" data-id="' + (p.id || '') + '" data-url="' + url + '">' +
                    '<div class="fav-item__img">' + imgHtml + '</div>' +
                    '<div class="fav-item__info">' +
                        '<a href="' + url + '" class="fav-item__name">' + name + '</a>' +
                        '<div class="fav-item__price-row">' +
                            (hasDiscount ? '<span class="fav-item__price-old">' + fmtPrice(regularPrice) + '</span>' : '') +
                            '<span class="fav-item__price">' + fmtPrice(price) + '</span>' +
                        '</div>' +
                        '<a href="#" class="link fav-item__add">Adicionar ao carrinho</a>' +
                    '</div>' +
                    '<button type="button" class="fav-item__remove" title="Remover" aria-label="Remover">' + TRASH_ICON_SVG + '</button>' +
                    '</div>';
            });
            gridEl.innerHTML = html;

            // Clique no item → navegar para o produto
            gridEl.querySelectorAll('.fav-item').forEach(function (item) {
                item.addEventListener('click', function (e) {
                    if (e.target.closest('.fav-item__add') || e.target.closest('.fav-item__remove') || e.target.closest('.fav-item__name')) return;
                    var url = item.dataset.url;
                    if (url && url !== '#') window.location.href = url;
                });
            });

            // Adicionar ao carrinho
            gridEl.querySelectorAll('.fav-item__add').forEach(function (link) {
                link.addEventListener('click', async function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var item = link.closest('.fav-item');
                    var productId = item && item.dataset.id;
                    if (!productId) return;
                    var origText = link.textContent;
                    link.textContent = 'Adicionando...';
                    try {
                        var result = await ApiWS.Calls.cartAddItem({ productId: productId, quantity: 1 });
                        // Produto com variação/KIT: a API pede a seleção (error_redirect) — leva pra página do produto.
                        if (result && (result.result === 'error_redirect' || result.error_code === 'PRODUCT_REQUIRES_SELECTION') && result.url_redirect) {
                            window.location.href = result.url_redirect;
                            return;
                        }
                        link.textContent = (result && result.result === 'success') ? 'Adicionado!' : 'Erro ao adicionar';
                    } catch (err) {
                        link.textContent = 'Erro ao adicionar';
                    }
                    setTimeout(function () { link.textContent = origText; }, 2000);
                });
            });

            // Remover da lista (visual)
            gridEl.querySelectorAll('.fav-item__remove').forEach(function (btn) {
                btn.addEventListener('click', function (e) {
                    e.stopPropagation();
                    var item = btn.closest('.fav-item');
                    if (item) item.remove();
                    if (gridEl.children.length === 0 && emptyEl) emptyEl.classList.remove('hidden');
                });
            });
        } catch (e) {
            if (loadingEl) loadingEl.classList.add('hidden');
            if (emptyEl) {
                emptyEl.textContent = 'Erro ao carregar favoritos.';
                emptyEl.classList.remove('hidden');
            }
        }
    }

    /* ═══════════════════════════════════════════════════════
       ENDEREÇOS
    ═══════════════════════════════════════════════════════ */
    function renderAddressCards() {
        var container = el('js-address-cards');
        if (!container) return;

        var html = '';
        _addresses.forEach(function (addr, idx) {
            html += '<div class="address-card hover-border-card" data-idx="' + idx + '">' +
                '<div class="address-card__head">' +
                    '<strong>' + (addr.label || 'Endereço ' + (idx + 1)) + (addr.main ? ' ★' : '') + '</strong>' +
                    '<span class="address-card__actions">' +
                        '<span class="link address-card__edit">Editar</span>' +
                        '<span class="link address-card__delete">Excluir</span>' +
                    '</span>' +
                '</div>' +
                (addr.address || '') + (addr.number ? ', ' + addr.number : '') + (addr.complement ? ' ' + addr.complement : '') + '<br>' +
                (addr.zipcode || '') + '<br>' +
                '<span class="city">' + (addr.city || '') + (addr.state ? ' – ' + addr.state : '') + '</span>' +
                '</div>';
        });
        container.innerHTML = html;

        // Eventos nos cards (clicar em qualquer parte, incluindo o link "Editar", abre o form)
        container.querySelectorAll('.address-card').forEach(function (card) {
            card.addEventListener('click', function () {
                selectAddress(parseInt(card.dataset.idx, 10));
            });
            var deleteLink = card.querySelector('.address-card__delete');
            if (deleteLink) {
                deleteLink.addEventListener('click', function (e) {
                    e.stopPropagation();
                    deleteAddress(parseInt(card.dataset.idx, 10));
                });
            }
        });
    }

    var addrAddBtn = el('js-addr-add-btn');
    if (addrAddBtn) {
        addrAddBtn.addEventListener('click', function (e) {
            e.preventDefault();
            selectAddress(-1);
        });
    }

    function showAddressList() {
        var listView = el('js-addr-list-view');
        var formView = el('js-addr-form-view');
        if (listView) listView.classList.remove('hidden');
        if (formView) formView.classList.add('hidden');
    }

    function showAddressForm() {
        var listView = el('js-addr-list-view');
        var formView = el('js-addr-form-view');
        if (listView) listView.classList.add('hidden');
        if (formView) formView.classList.remove('hidden');
    }

    var addrFormBackBtn = el('js-addr-form-back');
    if (addrFormBackBtn) {
        addrFormBackBtn.addEventListener('click', showAddressList);
    }

    function selectAddress(idx) {
        _selectedAddrIdx = idx;
        _lastSearchedCep = '';
        showAddressForm();

        var formTitle = el('js-addr-form-title');
        if (formTitle) formTitle.textContent = idx === -1 ? 'Novo endereço' : 'Editar endereço';

        if (idx === -1) {
            // Novo endereço
            setValue('js-addr-label', '');
            setValue('js-addr-recipient', _session ? (_session.nome || '') : '');
            setValue('js-cep-input', '');
            setValue('js-addr-street', '');
            setValue('js-addr-number', '');
            setValue('js-addr-complement', '');
            setValue('js-addr-neighborhood', '');
            setValue('js-addr-city', '');
            setSelect('js-addr-state', '');
            var mainCheck = el('js-addr-main');
            if (mainCheck) mainCheck.checked = _addresses.length === 0;
        } else {
            var addr = _addresses[idx];
            if (!addr) return;
            setValue('js-addr-label', addr.label || '');
            setValue('js-addr-recipient', addr.recipient || '');
            setValue('js-cep-input', formatCep(addr.zipcode || ''));

            // setValue() só atribui .value, sem disparar evento — searchCep() (que atualiza a
            // dica) nunca roda, e ela ficava travada no texto padrão do HTML ("Informe um CEP
            // válido") mesmo com um CEP já válido preenchido. Não dá pra só chamar searchCep()
            // aqui: ela busca no ViaCEP de verdade e SOBRESCREVE rua/bairro/cidade com o
            // resultado (podendo divergir do que o cliente salvou), além de roubar o foco pro
            // campo "Número" — errado só ao abrir a edição. Corrige só a dica, sem esses efeitos
            // colaterais; _lastSearchedCep marca como já validado, pra searchCep() não refazer a
            // busca à toa se o cliente reenviar o mesmo CEP sem alterar nada.
            var editCepDigits = onlyDigits(addr.zipcode || '');
            var editCepHint = el('js-cep-hint');
            if (editCepDigits.length === 8) {
                _lastSearchedCep = editCepDigits;
                if (editCepHint) editCepHint.textContent = '';
            } else {
                _lastSearchedCep = '';
                if (editCepHint) editCepHint.textContent = editCepDigits.length > 0 ? 'CEP inválido. Informe 8 dígitos.' : 'Informe um CEP válido';
            }

            setValue('js-addr-street', addr.address || '');
            setValue('js-addr-number', addr.number || '');
            setValue('js-addr-complement', addr.complement || '');
            setValue('js-addr-neighborhood', addr.neighborhood || '');
            setValue('js-addr-city', addr.city || '');
            setSelect('js-addr-state', addr.state || '');
            var mainChk = el('js-addr-main');
            if (mainChk) mainChk.checked = !!addr.main;
        }
        clearMsg('js-addr-msg');
    }

    // Busca CEP via ViaCEP — automática ao completar 8 dígitos, ao pressionar Enter ou ao sair do campo
    var cepInput = el('js-cep-input');
    if (cepInput) {
        var searchCep = async function () {
            var cep = onlyDigits(cepInput.value);
            var hintEl = el('js-cep-hint');
            if (cep.length !== 8) {
                if (hintEl) hintEl.textContent = cep.length > 0 ? 'CEP inválido. Informe 8 dígitos.' : 'Informe um CEP válido';
                return;
            }
            if (cep === _lastSearchedCep) return;
            _lastSearchedCep = cep;
            if (hintEl) hintEl.textContent = 'Buscando...';
            try {
                var resp = await fetch('https://viacep.com.br/ws/' + cep + '/json/');
                var result = await resp.json();
                if (result.erro) {
                    if (hintEl) hintEl.textContent = 'CEP não encontrado.';
                } else {
                    setValue('js-addr-street', result.logradouro || '');
                    setValue('js-addr-neighborhood', result.bairro || '');
                    setValue('js-addr-city', result.localidade || '');
                    setSelect('js-addr-state', result.uf || '');
                    if (hintEl) hintEl.textContent = '';
                    var numInput = el('js-addr-number');
                    if (numInput) numInput.focus();
                }
            } catch (e) {
                if (hintEl) hintEl.textContent = 'Erro ao buscar CEP. Preencha manualmente.';
            }
        };

        // Formatação automática do CEP: 00000-000 + busca ao completar o 8º dígito
        cepInput.addEventListener('input', function () {
            cepInput.value = formatCep(cepInput.value);
            if (onlyDigits(cepInput.value).length === 8) searchCep();
        });

        cepInput.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') searchCep();
        });

        cepInput.addEventListener('blur', function () {
            searchCep();
        });
    }

    // Salvar endereço
    var addrSaveBtn = el('js-addr-save-btn');
    if (addrSaveBtn) {
        addrSaveBtn.addEventListener('click', async function () {
            clearMsg('js-addr-msg');

            var label = ((el('js-addr-label') || {}).value || '').trim() || 'Principal';
            var recipient = ((el('js-addr-recipient') || {}).value || '').trim();
            var zipcode = onlyDigits((el('js-cep-input') || {}).value || '');
            var street = ((el('js-addr-street') || {}).value || '').trim();
            var number = ((el('js-addr-number') || {}).value || '').trim();
            var complement = ((el('js-addr-complement') || {}).value || '').trim();
            var neighborhood = ((el('js-addr-neighborhood') || {}).value || '').trim();
            var city = ((el('js-addr-city') || {}).value || '').trim();
            var state = ((el('js-addr-state') || {}).value || '').toUpperCase().trim();
            var isMain = !!(el('js-addr-main') || {}).checked;

            if (!recipient || !zipcode || !street || !number || !neighborhood || !city || !state) {
                setMsg('js-addr-msg', 'Preencha todos os campos obrigatórios.', 'error');
                return;
            }

            // Monta array de endereços atualizado
            var updatedAddresses = _addresses.map(function (a, i) {
                var copy = Object.assign({}, a);
                if (isMain) copy.main = (i === _selectedAddrIdx);
                return copy;
            });

            var editedAddr = {
                id: _selectedAddrIdx >= 0 ? (_addresses[_selectedAddrIdx].id || 0) : 0,
                main: isMain,
                label: label,
                recipient: recipient,
                zipcode: zipcode,
                address: street,
                number: number,
                complement: complement,
                neighborhood: neighborhood,
                city: city,
                state: state
            };

            if (_selectedAddrIdx >= 0) {
                updatedAddresses[_selectedAddrIdx] = editedAddr;
            } else {
                // Novo endereço: se main, desmarca os outros
                if (isMain) {
                    updatedAddresses = updatedAddresses.map(function (a) {
                        return Object.assign({}, a, { main: false });
                    });
                }
                updatedAddresses.push(editedAddr);
            }

            setLoading('js-addr-save-btn', true);
            try {
                var data = await ApiWS.Calls._post('/user/data/personal-info/save', {
                    addresses: updatedAddresses
                });
                if (data && data.result === 'success') {
                    _addresses = updatedAddresses;
                    if (_selectedAddrIdx < 0) _selectedAddrIdx = _addresses.length - 1;
                    renderAddressCards();
                    clearMsg('js-addr-msg');
                    showAddressList();
                } else {
                    setMsg('js-addr-msg', (data && data.message) || 'Erro ao salvar endereço.', 'error');
                }
            } catch (e) {
                setMsg('js-addr-msg', 'Erro de conexão. Tente novamente.', 'error');
            }
            setLoading('js-addr-save-btn', false);
        });
    }

    // Excluir endereço (chamado a partir do link "Excluir" na listagem)
    async function deleteAddress(idx) {
        if (idx < 0 || !_addresses[idx]) return;
        if (!confirm('Deseja excluir este endereço?')) return;

        var remaining = _addresses.filter(function (_, i) { return i !== idx; });

        // Se o excluído era o principal e ainda há endereços, o primeiro fica como principal
        if (_addresses[idx].main && remaining.length > 0) {
            remaining[0] = Object.assign({}, remaining[0], { main: true });
        }

        try {
            var data = await ApiWS.Calls._post('/user/data/personal-info/save', {
                addresses: remaining
            });
            if (data && data.result === 'success') {
                _addresses = remaining;
                if (_selectedAddrIdx === idx) _selectedAddrIdx = -1;
                renderAddressCards();
            } else {
                alert((data && data.message) || 'Erro ao excluir endereço.');
            }
        } catch (e) {
            alert('Erro de conexão. Tente novamente.');
        }
    }

    /* ═══════════════════════════════════════════════════════
       INICIALIZAÇÃO
    ═══════════════════════════════════════════════════════ */
    initSession();

})();
